<template>
  <detail
    :onManager="onManager"
    :data="data"
    :base-info="baseInfo"
    :hiddenKeys="['status', 'zone', 'region']"
    resource="bastion_hosts" />
</template>

<script>
import {
  getPublicScopeTableColumn,
} from '@/utils/common/tableColumn'
import {
  getUserTagColumn,
  getExtTagColumn,
} from '@/utils/common/detailColumn'
import {
  getAccessUrl,
  getProviderTableColumn,
} from '../utils/columns'

export default {
  name: 'BastionHostDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        getPublicScopeTableColumn({ vm: this, resource: 'bastion_hosts' }),
        getProviderTableColumn(),
        getAccessUrl(),
        getUserTagColumn({
          onManager: this.onManager,
          resource: 'bastion_hosts',
          columns: () => this.columns,
          tipName: this.$t('bastionHost.title'),
        }),
        getExtTagColumn({
          onManager: this.onManager,
          resource: 'bastion_hosts',
          columns: () => this.columns,
          tipName: this.$t('bastionHost.title'),
        }),
      ],
    }
  },
}
</script>
